import { render, staticRenderFns } from "./ResultMonitorRatingContent.vue?vue&type=template&id=12a4a2c8&scoped=true"
import script from "./ResultMonitorRatingContent.vue?vue&type=script&lang=js"
export * from "./ResultMonitorRatingContent.vue?vue&type=script&lang=js"
import style0 from "./ResultMonitorRatingContent.vue?vue&type=style&index=0&id=12a4a2c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a4a2c8",
  null
  
)

export default component.exports